import React, { useEffect, useState } from "react";
import { classNames, useTranslate } from "helpers";
import { getFleetSettingsAPI } from "services/api/settings/fleet/api";
import { FleetSettingVehicleCategory } from "services/api/settings/fleet/types";
import { VehicleCategoryPickerProps } from "./types";

const VehicleCategoryPicker: React.FC<VehicleCategoryPickerProps> = (props) => {
  const { name, value, onChange } = props;
  const { t } = useTranslate();

  const [categories, setCategories] = useState<FleetSettingVehicleCategory[]>([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const result = await getFleetSettingsAPI();
        setCategories(
          [...result.selectedVehicleCategories].sort((a, b) => a.id.localeCompare(b.id))
        );
      } catch {
        return;
      }
    };
    fetchCategories();
  }, []);

  if (categories.length <= 1) return null;

  const handleClick = (e: React.MouseEvent, category: FleetSettingVehicleCategory) => {
    onChange(e, name, { value: category.id, text: category.name });
  };

  return (
    <div className="flex flex-col gap-2 w-full">
      <div>
        <label className="block text-sm font-medium leading-6 text-[#344054]">
          {t("admin.fleet.vehicle.category")}
        </label>
        <p className="text-xs text-slate-400 mt-0.5">{t("admin.fleet.vehicle.category.description")}</p>
      </div>
      <div className="flex gap-3 w-full">
      {categories.map((category) => {
        const isSelected = value === category.id;

        return (
          <button
            key={category.id}
            type="button"
            onClick={(e) => handleClick(e, category)}
            className={classNames(
              "flex flex-1 flex-col items-center gap-2 px-5 py-3 rounded-sm border transition-all cursor-pointer",
              isSelected
                ? "border-sky-500 bg-sky-50 text-sky-700"
                : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50"
            )}
          >
            {/* <img src={icon} alt="" className="w-8 h-8 object-contain" /> */}
            <span className="text-sm font-medium text-center">{category.name}</span>
          </button>
        );
      })}
      </div>
    </div>
  );
};

export default React.memo(VehicleCategoryPicker);
